import { render, staticRenderFns } from "./srViewingAs.vue?vue&type=template&id=0efb7f3c&scoped=true"
import script from "./srViewingAs.vue?vue&type=script&lang=js"
export * from "./srViewingAs.vue?vue&type=script&lang=js"
import style0 from "./srViewingAs.vue?vue&type=style&index=0&id=0efb7f3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efb7f3c",
  null
  
)

export default component.exports